// @figma file=pkCGby54zXzTsccXvHqzO6 node=tbd name="AppShell" set="mytaible-shadcn-studio" verified=tbd
import * as React from 'react';
import { ShellSkeleton } from './shell-skeleton';
import type { AppShellLayout, AppShellProps } from './types';

// ─── Shell registry ───────────────────────────────────────────────────────────
//
// Each entry lazy-loads a single shell chunk.
// Only the active shell is included in the initial bundle.
//
// To add a new shell:
//   1. Create  ./shells/shell-XX-<name>.tsx  (default export, accepts AppShellProps)
//   2. Add an entry below
//   3. Uncomment the layout key in types.ts → AppShellLayout

const SHELLS: Record<
  AppShellLayout,
  React.LazyExoticComponent<React.ComponentType<AppShellProps>>
> = {
  'app-shell-01': React.lazy(() => import('./shells/shell-01-dual-sidebar')),
  'app-shell-02': React.lazy(() => import('./shells/shell-02-sidebar-nav')),
  'app-shell-03': React.lazy(() => import('./shells/shell-03-dark-sidebar')),
  'app-shell-04': React.lazy(() => import('./shells/shell-04-topbar-nav')),
  'app-shell-05': React.lazy(() => import('./shells/shell-05-mobile-overlay')),
  'app-shell-06': React.lazy(() => import('./shells/shell-06-mobile-only')),
  'app-shell-18': React.lazy(() => import('./shells/shell-18-dashboard-footer')),
};

// ─── AppShell ─────────────────────────────────────────────────────────────────

export function AppShell({ layout = 'app-shell-01', ...props }: AppShellProps) {
  const Shell = SHELLS[layout];
  return (
    <React.Suspense fallback={<ShellSkeleton />}>
      <Shell layout={layout} {...props} />
    </React.Suspense>
  );
}
